import React from 'react';
import debounce from 'lodash/debounce';
import PropTypes from 'prop-types';
import { percentageAsValue } from './tools/slider-control-conversions';
import sendToGoogleAnalytics from '../_libs/analytics/builder-send-to-google-analytics';
import stringParameterize from './string-parameterize';

// -----------------------------------------------------------
//  MananaSlider
// -----------------------------------------------------------

class MananaSlider extends React.Component {
  state = {
    previousValue: null,
    currentValue: this.props.value,
  };

  debouncedHandleChange = debounce(() => {
    const { previousValue, currentValue } = this.state;
    const { handleChange } = this.props;
    const diff = currentValue - previousValue;

    handleChange(currentValue, diff);
  }, this.threshold);

  shouldComponentUpdate(nextProps, nextState) {
    const { disabled } = this.props;
    const { currentValue } = this.state;

    return (
      currentValue !== nextState.currentValue || disabled !== nextProps.disabled
    );
  }

  get threshold() {
    const { threshold } = this.props;
    return parseInt(threshold, 10) || 20;
  }

  handleChange = (event) => {
    if (this.props.disabled) return;
    const newValue = event.target ? event.target.value : event;

    this.setState(
      {
        currentValue: Number(newValue),
      },
      this.debouncedHandleChange,
    );
  };

  handleClick = () => {
    const { label, disabled } = this.props;
    if (disabled) return;

    sendToGoogleAnalytics('el2', `${stringParameterize(label)}`);
  };

  handleTouchMove = (event) => {
    const { min, max, disabled } = this.props;
    if (disabled) return;

    const { left, width, right } = event.target.getBoundingClientRect();
    const touchOffset = event.touches[0].clientX;
    const touchLeftPos = touchOffset - left;
    const touchRightPos = right - touchOffset;

    if (touchLeftPos >= 0 && touchRightPos >= 0) {
      const percentage = Math.round((touchLeftPos / width) * 100);
      this.handleChange(percentageAsValue({ percentage, min, max }));
    }
  };

  set = (val) => {
    let newValue = val;
    const { value } = this.props;

    if (newValue === null || newValue === undefined) {
      newValue = Number(value);
    }

    this.setState((prevState) => ({
      previousValue: prevState.currentValue,
      currentValue: newValue,
    }));
  };

  reset = () => this.set(null);

  render() {
    const { id, className, min, max, step, disabled, label } = this.props;
    const { currentValue } = this.state;
    const propagatingProps = { id, className, min, max, step, disabled };

    return (
      <input
        type="range"
        {...propagatingProps}
        value={currentValue}
        tabIndex="0"
        aria-valuetext={`${label || ''} value: ${currentValue}`}
        aria-valuemin={min}
        aria-valuemax={max}
        aria-valuenow={currentValue}
        onTouchMove={this.handleTouchMove}
        onChange={this.handleChange}
        onClick={this.handleClick}
      />
    );
  }
}

MananaSlider.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  handleChange: PropTypes.func,
  threshold: PropTypes.number,
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  value: PropTypes.number,
};

MananaSlider.defaultProps = {
  disabled: false,
};

export default MananaSlider;
